module.exports = __webpack_public_path__ + "img/title_wizai.ac18f6ef.png";